import { Expandable } from "@components/atoms/Expandable"
import { Appear } from "@components/motion/Appear"
import { defineBlock, EditableText, InnerBlocks, SingleContentBlock, useBlockContext } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "FAQ Item",
}

export default defineBlock("section/faq-item", (props) => {
  const info = useBlockContext()
  const index = info?.index || 0

  return (
    <Appear delay={(index + 1) * 50} className="faq-item w-full text-pretty">
      <Expandable
        label={<EditableText store="faqItemQuestion" as="p" placeholder="Example title" />}
        className="w-full"
        buttonClassName="py-5 type-header-s border-b-[#e2e2e2]"
        contentClassName="[&_p]:!mb-4 md:pr-8 [&_p_a]:!underline [&_p_a]:!font-normal"
        icon={
          <svg className="w-8 h-8 md:w-6 md:h-6" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.25 8C16.6642 8 17 8.33579 17 8.75V15.5H23.75C24.1642 15.5 24.5 15.8358 24.5 16.25C24.5 16.6642 24.1642 17 23.75 17H17V23.75C17 24.1642 16.6642 24.5 16.25 24.5C15.8358 24.5 15.5 24.1642 15.5 23.75V17H8.75C8.33579 17 8 16.6642 8 16.25C8 15.8358 8.33579 15.5 8.75 15.5H15.5V8.75C15.5 8.33579 15.8358 8 16.25 8Z"
              fill="currentColor"
            />
          </svg>
        }
        iconOpen={
          <svg className="w-8 h-8 md:w-6 md:h-6" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 15.75C8 15.3358 8.33579 15 8.75 15H22.75C23.1642 15 23.5 15.3358 23.5 15.75C23.5 16.1642 23.1642 16.5 22.75 16.5H8.75C8.33579 16.5 8 16.1642 8 15.75Z"
              fill="currentColor"
            />
          </svg>
        }
      >
        <InnerBlocks
          allowedBlocks={["#inline"]}
          template={[["core/paragraph", { placeholder: "Example answer text..." }]]}
        />
      </Expandable>
    </Appear>
  )
})
